import { useState } from "react";
import { RequestQuotePayloadType } from "../types/types";
import { postSendRequestQuote } from "../api/ApiService";

export const useRequestQuote = () => {
  const [requestQuoteForPart, setRequestQuoteForPart] = useState<RequestQuotePayloadType | null>(null);
  const [saving, setSaving] = useState(false);

  const close = () => {
    setRequestQuoteForPart(null);
  };

  const onSend = async (name: string, email: string, phoneNumber: string, message: string, shop: string) => {
    const sku = requestQuoteForPart?.sku;
    if (!sku) {
      console.error("No part sku found for request quote");
      return;
    }

    console.log("Sending request for part", requestQuoteForPart, name, email, phoneNumber, message);
    setSaving(true);

    try {
      await postSendRequestQuote(name, email, phoneNumber, message, sku, shop);

      alert("Thank you for your inquiry! Request sent successfully, we will get back to you soon.");
      close();
    } catch (e) {
      alert("Error sending request. Please try again!");
    }

    setSaving(false);
  };

  return {
    requestQuoteForPart,
    saving,
    setRequestQuoteForPart,
    close,
    onSend,
  };
};
